// Compiler result to JSON file
import { createComponent } from 'js/declViewModelService';
import { registerDynImportEntry } from 'js/moduleLoader';
import AwParseService from 'js/awParseService';
import AwFilterService from 'js/awFilterService';
import { getField } from 'js/utils';
import { Fragment } from 'react';
let filterSer = AwFilterService.instance;

/*
render function
*/
import { searchResultsCellRenderFunction } from 'js/searchResultsCellService';

/*
ctx imports
*/

const ctxImportObj = {};

/*
dynamic import
 */
registerDynImportEntry('js/searchResultsCellService', () => import('js/searchResultsCellService'));
;

/*
view model
 */
const declViewModelJson = {
  "schemaVersion": "1.0.0",
  "actions": {
    "render": {
      "method": "searchResultsCellRenderFunction",
      "deps": "js/searchResultsCellService"
    }
  },
  "data": {},
  "conditions": {},
  "onEvent": [],
  "lifecycleHooks": {
    "render": "render"
  },
  "props": {
    "item": {
      "type": "viewModelObject"
    },
    "vmo": {
      "type": "viewModelObject"
    },
    "hideoverlay": {
      "type": "string"
    },
    "accsessionid": {
      "type": "string"
    }
  },
  "_viewModelId": "SearchResultsCell",
  "_uniqueViewModelId": "SearchResultsCell",
  "ctx": {}
};

/*
define component
*/
const Component = createComponent(declViewModelJson, searchResultsCellRenderFunction, undefined, ctxImportObj);
export default Component;